import Nav from './Nav';
import Footer from './Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function Instructions() {
  const screenshots = [
    {
      src: "/instruction_1.png",
      alt: "nibblet share info"
    },
    {
      src: "/instruction_2.png",
      alt: "nibblet app home screen"
    },
    {
      src: "/instruction_3.png",
      alt: "nibblet app recipe details screen"
    },
  ];

  return (
    <>
      <Nav />
      <main className="main-content">
        <section className="section-container">
          <h2 className="hero-title">Instructions</h2>
          
          {/* Desktop: Show all screenshots side by side */}
          <div className="app-showcase app-showcase-desktop">
            {screenshots.map((screenshot, index) => (
              <img 
                key={index}
                src={screenshot.src}
                alt={screenshot.alt}
                className="app-screenshot"
              />
            ))}
          </div>

          {/* Mobile: Show carousel */}
          <div className="app-showcase app-showcase-mobile">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              pagination={{ 
                clickable: true,
                el: '.custom-pagination'
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              loop={true}
              className="app-swiper"
            >
              {screenshots.map((screenshot, index) => (
                <SwiperSlide key={index}>
                  <img 
                    src={screenshot.src}
                    alt={screenshot.alt}
                    className="swiper-screenshot"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="custom-pagination"></div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default Instructions;